// Short-lived cache of the Client Requirements list, so going back and forth
// between screens doesn't refetch it. Held in memory, not sessionStorage: a
// browser reload (F5) always loads fresh data.
//
// Sprint-side actions can change a requirement on the server (its sprint follows
// a ticket move; it becomes Production after a live-move approval), so they call
// invalidateRequirementsCache() and the Client Requirements screen loads fresh
// data next time. Only this browser's cache — other users still see theirs until
// it expires or they reload.
const CR_DATA_TTL_MS = 5 * 60 * 1000; // 5 minutes
let cached = null; // { projectId, ts, data }

export const loadCachedRequirements = (projectId) => {
  if (!cached || String(cached.projectId) !== String(projectId)) return null;
  if (Date.now() - cached.ts > CR_DATA_TTL_MS) return null;
  return cached.data;
};

export const saveCachedRequirements = (projectId, data) => {
  cached = { projectId: String(projectId), ts: Date.now(), data };
};

export const invalidateRequirementsCache = () => {
  cached = null;
  // Older builds kept the list in sessionStorage; drop any copy left behind.
  try { sessionStorage.removeItem("fixdesk:clientReqData:v1"); } catch { /* storage unavailable */ }
};
